// Which live-feed events are PROGRESS, and so deserve to be shouty.
//
// The wall TV is read at a distance. Most rows are activity - a comment, a
// move, a review - and they should recede. A row where something FINISHED is
// different: the team closed a ticket or landed a pull request, and that is the
// thing an operator glancing up actually wants to see.
//
// Read from the payload rather than the rendered text, because `rule_description`
// is operator-curated and may say anything at all.

export interface SignificantEvent {
  type: string;
  payload?: Record<string, unknown> | null;
}

/**
 * Terminal statuses. These are per-team configuration in the API
 * (`adventure_config.terminal_status_names`) and the default there is these two.
 * Passed in rather than reached for, so the assumption is visible and a caller
 * that knows better can say so.
 */
export const DEFAULT_TERMINAL_STATUSES = ['Done', 'Cancelled'];

export function isSignificantEvent(
  ev: SignificantEvent,
  terminalStatuses: readonly string[] = DEFAULT_TERMINAL_STATUSES,
): boolean {
  // A pull request closing is progress whether it was merged or abandoned -
  // either way, someone stopped having to think about it.
  if (ev.type === 'pr.closed') return true;

  // A ticket moving INTO a terminal status is the closing move. A move out of
  // one (a reopen) is not progress, and is deliberately not counted here.
  if (ev.type === 'issue.transition') {
    const to = (ev.payload?.transition as { to?: unknown } | undefined)?.to;
    return typeof to === 'string' && terminalStatuses.includes(to);
  }

  return false;
}
